<body class="home-page01 container-fluid p528">
  <div class="content">
    <div class="main">
      <div class="container-fluid full-width">
        <div class="top-cont">
          <div class="business-services__container_pay">
            <div class="div-bus cus-bnd">

              <span>
                <h3 class="product-disc bnd-0">Product Disclosure
                </h3><br>
                <hr class="hr_bus">
              </span>


            </div>

          </div>
          <img class="vector-01" src="../../../../assets/redesignImages/Vector.png">

        </div>

        <div class="dis-up up-1">
          <p><b> For C.O.D., offered through UPS Capital<sup>®</sup> Trade Protection Services</b></p>
          <p class="subhead">C.O.D. enhancement services are offered through UPS Capital Trade Protection
            Services, Inc. UPS
            Capital Corporation and its affiliates reserve the right to change or cancel any C.O.D.
            enhancement services program at any time. Each C.O.D. enhancement services program is governed
            by the applicable terms and conditions governing participation in that program and certain
            limitations and exclusions apply. Information contained in this web site information does not in
            any way alter, supplement or amend the applicable terms and conditions governing participation
            in any C.O.D. enhancement services program and is intended only as a brief summary of that
            program. The UPS<sup>®</sup> C.O.D. charges, as set forth in the UPS rates in effect at the time
            of
            shipping, apply to each UPS C.O.D. package shipped. Some C.O.D. enhancement services may involve
            loans or the advancement of funds for anticipated C.O.D. receipts. Loans made in California are
            pursuant to a Department of Corporations California Finance Lenders License. C.O.D. Enhancement
            Services products may not be available in all jurisdictions and may be modified based on
            requirements. Check with your UPS Capital representative for local availability. Credit
            availability is subject to approval. C.O.D. Secure, C.O.D. Automatic and C.O.D. Direct are
            registered trademarks of United Parcel Service of America, Inc.</p>
          <p class="space"></p>
          <p><b>Insurance</b></p>
          <p class="subhead">Insurance coverage is underwritten by an authorized insurance company and offered
            through UPS Capital Insurance Agency, Inc., a licensed insurance producer. All descriptions or
            illustrations of coverage are provided for general informational purposes only and do not in any
            way alter or amend the terms, conditions, or exclusions of any insurance policy or
            program.&nbsp; For certain users, you may elect to protect your shipment under a policy of
            insurance, but you are not an insured under the policy. In the event of a loss covered under
            such policy, any resulting claim payment will be directed to you as a loss payee.&nbsp;
            Insurance coverage is not available in all jurisdictions, on all shipments, or to all
            customers.&nbsp; &nbsp;</p>
          <p class="space"></p>

          <p><b>DeliveryDefense™ Services
            </b></p>
          <p class="subhead">DeliveryDefense™ services are offered through UPS Capital Corporation. UPS
            Capital Corporation reserves the right to change or cancel any DeliveryDefense service at any
            time. Each DeliveryDefense service is governed by the applicable terms and conditions and
            certain limitations and exclusions apply. This document/site is for informational purposes only,
            is intended only as a brief summary of the services, and does not constitute a contract,
            agreement, or offer of any kind, with respect to any DeliveryDefense service or other subject
            matter described herein. DeliveryDefense services may not be available in all jurisdictions.</p>
          <p class="space"></p>
          <p><b>Merchant Services Program Disclaimer</b></p>
          <p class="subhead">All services in connection with the UPS Capital<sup>®</sup> Merchant Services
            Program are provided by
            Paymentech, LLC, an affiliate of JP Morgan Chase Bank, N.A. All decisions regarding approval of
            a merchant services application, and all fees charged for merchant services, are determined
            solely by Paymentech, LLC.</p>
          <p class="space"></p>
          <p><b>Continuous Customs Bonds</b></p>
          <p class="subhead">Customs Bonds are underwritten by an authorized insurance company and issued
            through licensed insurance producers affiliated with UPS Capital Insurance Agency, Inc., and
            other affiliated insurance agencies. UPS Capital Insurance Agency, Inc. and its licensed
            affiliates are wholly owned subsidiaries of UPS Capital Corporation. The insurance company, UPS
            Capital Insurance Agency, Inc. and its licensed affiliates reserve the right to change or cancel
            the program at any time.</p>
          <p class="space"></p>

          <p><b>Parcel Pro Disclaimer</b></p>
          <p class="subhead">Insurance coverage is offered through Parcel Pro, Inc., a licensed insurance
            producer, and provided under an insurance policy issued by an authorized insurance company. If
            you elect protection for your shipment, it will be insured under a policy of insurance (the
            “Policy”), but you are not an insured under the Policy. In the event of a loss covered under
            such Policy, any resulting claim payment will be directed to you as a loss payee. Insurance
            coverage is not available in all jurisdictions or on all shipments. Additional terms,
            restrictions and conditions apply. Please speak to a sales representative for more details.</p>
          <p class="btn-space"></p>


        </div>

      </div>


    </div>
  </div>
</body>